import React from 'react';

import TimerBadge from 'components/TimerBadge';
import Modal, { ModalType } from 'legacy/common/components/modal/Modal';
import Button from 'components/Button';
import { FaArrowRotateLeft } from 'react-icons/fa6';
import Link from 'next/link';
import { useViewEvent } from 'features/events/context/ViewEvent';
import { useCheckout } from 'features/events/checkout/context';
import { useTranslation } from 'react-i18next';

const CheckoutTimer = () => {
  const { event } = useViewEvent();
  const { checkoutTimer } = useCheckout();
  const { t } = useTranslation(['checkout', 'events']);

  return (
    <>
      <TimerBadge timeLeft={checkoutTimer.timeLeft} />
      <Modal
        type={ModalType.SMALL}
        shouldStopModalClose
        autoHeight
        noPadding
        visible={checkoutTimer.isExpired}
        hideCloseButton
      >
        <div className="h-full pb-24 pt-14 md:pb-16 overflow-auto max-h-[95vh] md:max-h-[600px] relative bg-[radial-gradient(circle_at_right_bottom,#A3BEFD,transparent_35%)]">
          <div className="flex flex-col items-center justify-center gap-5 p-4 text-center">
            <div className="text-4xl">⌛</div>
            <h2 className="text-3xl font-black uppercase">
              {t('checkout:timer.timeUp')}
            </h2>
            <p className="text-neutral-500 font-normal text-lg">
              {t('checkout:timer.checkoutExpired')}
              <br />
              {t('checkout:timer.readyToJumpBackIn')}
            </p>
            <Button
              onClick={checkoutTimer.resetTimer}
              variant="primaryDark"
              size="xlarge"
            >
              {t('checkout:timer.restartCheckout')}{' '}
              <FaArrowRotateLeft size={18} className="ml-3" />
            </Button>
            <Link
              href={`/events/${event?._id}`}
              className="text-primary-500 text-base text-normal"
            >
              {t('events:actions.viewEvent')}
            </Link>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default CheckoutTimer;
